import dayjsGenerateConfig from '@rc-component/picker/lib/generate/dayjs';
import generateCalendar from './generateCalendar';
const Calendar = generateCalendar(dayjsGenerateConfig);
Calendar.generateCalendar = generateCalendar;
export default Calendar;
